import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import relatorioEntregasService from "./RelatorioEntregasService";
import {
    FaHome,
    FaLink,
    FaUnlink
} from "react-icons/fa";
import InputField from "../../componentes/form-fields/InputField/InputField";
import CustomDatePicker from "../../componentes/form-fields/DatePicker/CustomDatePicker";
import RelatorioEntregasDialog from "./RelatorioEntregasDialog";

export default function RelatorioEntregas() {
    const { t } = useTranslation();
    const { control } = useForm();

    const userId = sessionStorage.getItem("userId");

    const initialRelatorioEntregasState = {
        idEntrega: 0,
        numeroNfe: '',
        nomeCliente: '',
        dataInicialNFe: null,
        dataFinalNFe: null,
        dataInicialImportacaoNFe: null,
        dataFinalImportacaoNFe: null,
        openDialog: false
    };

    const [relatorioEntregas, setRelatorioEntregas] = useState(initialRelatorioEntregasState);

    const { idEntrega ,numeroNfe, nomeCliente, dataInicialNFe, dataFinalNFe, dataInicialImportacaoNFe, dataFinalImportacaoNFe, warningRelatorioEntregas, warningMessage, openDialog } = relatorioEntregas

    const [clearedRelatorioEntregas, setClearedRelatorioEntregas] = useState(false);
    const [programRoleRows, setRelatorioEntregasRows] = useState([]);

    const columnsRelatorioEntregas = (t) => [
        {
            field: "idEntregaCliente",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="idEntregaCliente" />;
            },
        },
        {
            field: "numeroNFe",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="numeroNfe" />;
            },
        },
        {
            field: "nomeCliente",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="nomeCliente" />;
            },
        },
        {
            field: "dataNota",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="dataNota" />;
            },
        },
        {
            field: "dataImportacaoNota",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="dataImportacaoNota" />;
            },
        },
    ];


    const handleCloseDialog = close => {
        if(!close){
            setTimeout(() => { 
                setRelatorioEntregas({
                    openDialog: false
                })
            }, 100);
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setRelatorioEntregas({ ...relatorioEntregas, [name]: value });
    };

    const handleCloseAlertRelatorioEntregas = () => {
        setRelatorioEntregas({ ...relatorioEntregas, warningRelatorioEntregas: false });
    };

    const handleClearRelatorioEntregas = () => {
        setClearedRelatorioEntregas(!clearedRelatorioEntregas);
        setRelatorioEntregas(initialRelatorioEntregasState);
        setRelatorioEntregasRows([]);
    };

    const handleSearchRelatorioEntregas = () => {
        let request = { ...relatorioEntregas }
        relatorioEntregasService
            .get(request)
            .then((response) => {

                response.data.forEach((program, index) => {
                    program.id = index
                    program.idRole = request.idRole
                })
                setRelatorioEntregasRows(response.data)
            })
            .catch((e) => {
                handleWarningRelatorioEntregas();
            });
    };

    const handleWarningRelatorioEntregas = () => {
        setRelatorioEntregasRows([]);
        if (relatorioEntregas.idRole !== 0) {
            setRelatorioEntregas({ ...relatorioEntregas, warningRelatorioEntregas: true });
        }
    };

    const handleClickGrid = (rowData) => {
        setTimeout(() => { 
            setRelatorioEntregas({
                idEntrega: rowData.idEntregaCliente,
                openDialog: true
            })
        }, 100);
    }

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="relatorioEntrega"
                fields={
                    <>
                        <RelatorioEntregasDialog
                            _idEntrega={idEntrega}
                            openDialog={openDialog}
                            handleCloseDialog={handleCloseDialog}
                        />
                        <GridItemContainer>
                            <CustomAlert
                                message={warningMessage}
                                warning={warningRelatorioEntregas}
                                handleCloseAlert={handleCloseAlertRelatorioEntregas}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={12} md={6}>
                                    <InputField
                                        name="numeroNfe"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={numeroNfe}
                                        length={50}
                                        error={warningRelatorioEntregas && numeroNfe === ""}
                                    />
                                </Grid>
                                <Grid item xs={4} sm={3} md={6}>
                                    <InputField
                                        name="nomeCliente"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={nomeCliente}
                                        length={50}
                                        error={warningRelatorioEntregas && nomeCliente === ""}
                                    />
                                </Grid>
                            </GridInputRow>
                            <GridInputRow>

                                <Grid item xs={12} sm={6} md={3}>
                                    <CustomDatePicker
                                        id="dataInicialNFe"
                                        name="dataInicialNFe"
                                        selectedDate={dataInicialNFe}
                                        handleChange={handleChange}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <CustomDatePicker
                                        id="dataFinalNFe"
                                        name="dataFinalNFe"
                                        selectedDate={dataFinalNFe}
                                        handleChange={handleChange}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <CustomDatePicker
                                        id="dataInicialImportacaoNFe"
                                        name="dataInicialImportacaoNFe"
                                        selectedDate={dataInicialImportacaoNFe}
                                        handleChange={handleChange}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <CustomDatePicker
                                        id="dataFinalImportacaoNFe"
                                        name="dataFinalImportacaoNFe"
                                        selectedDate={dataFinalImportacaoNFe}
                                        handleChange={handleChange}
                                    />

                                </Grid>
                            </GridInputRow>
                            <SearchClearSaveRow
                                onClickClear={handleClearRelatorioEntregas}
                                onClickSearch={handleSearchRelatorioEntregas}
                            />

                        </GridItemContainer>
                    </>
                }
            />
            {programRoleRows.length > 0 ? (
                <DefaultScreenAccordion

                    fields={
                        <DefaultDatagrid
                            columns={columnsRelatorioEntregas(t, handleSearchRelatorioEntregas)}
                            dataSource={programRoleRows}
                            allowPaging={true}
                            cellSelected={(args, grid) => handleClickGrid(args.data)}
                            Export
                        />
                    } />
            ) : null}
        </>
    );
};
